module.exports = __webpack_public_path__ + "img/no-operations.d3ed4c0f.svg";